import {
	Table,
	TableSectionsData,
} from '@/libraries/design/patterns/pricing-table/src/table/table.tsx';
import { useDwellTimeElementAttributes } from '@/utils/dwell-tracking/dwell-tracker-hooks.ts';

import { useTableData } from './hooks';
import { ContentfulFeature } from './types.ts';
import { transformContentfulDataToTableData } from './utils';

export interface PricingTableWithFetchProps {
	urlSlug: string;
	locale: string;
}

export const PricingTableWithFetch = ({ urlSlug, locale }: PricingTableWithFetchProps) => {
	const { tableData, planTitles, hasError } = useTableData({
		urlSlug,
		locale,
	});

	const dwellTimeAttributes = useDwellTimeElementAttributes({
		id: 'pricing-table',
	});

	if (!tableData.length || hasError) {
		return null;
	}

	const transformedSections = transformContentfulDataToTableData(
		tableData as ContentfulFeature[],
		planTitles,
	);

	return (
		<div {...dwellTimeAttributes}>
			<Table
				header={{ titles: ['', ...planTitles] }}
				sections={transformedSections as TableSectionsData}
			/>
		</div>
	);
};
